
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/festivals/[festivalId]/notice",
      function () {
        return require("private-next-pages/festivals/[festivalId]/notice/index.tsx");
      }
    ]);
  